<template>
  <Modal title="编辑关闭时间" v-model="visible" :width="800">
    <Form ref="timeForm" class="form" :label-width="90"
          :model="timeParam" :rules="timeRule">
      <Row>
        <Col :span="26">
          <Form-item label="选择关闭时间" prop="openedTime">
            <Row :gutter="12">
              <Col :span="4">
                <Form-item prop="week">
                  <Select placeholder="星期" v-model="timeParam.week" transfer>
                    <Option v-for="item in $constant.week"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :span="5">
                <Form-item prop="startTime">
                  <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                               :steps="[1, 5]" :value="timeParam.startTimeStr"
                               @on-change="onChangeStratTime"></Time-picker>
                </Form-item>
              </Col>
              <Col :span="1"></Col>
              <Col :span="5">
                <Form-item prop="endTime">
                  <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                               :steps="[1, 5]" :value="timeParam.endTimeStr"
                               @on-change="onChangeEndTime"></Time-picker>
                </Form-item>
              </Col>
            </Row>
            <Row :gutter="12">
              <i-col :span="8">
                <Form-item prop="useDate">
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="生效日期"
                               @on-change="onChangeUseDate" :clearable="false"
                               :value="timeParam.useDateStr"></Date-picker>
                </Form-item>
              </i-col>
              <i-col :span="8">
                <Form-item prop="endDate">
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="结束日期,不包含当天"
                               @on-change="onChangeEndDate" :clearable="false"
                               :value="timeParam.endDateStr"></Date-picker>
                </Form-item>
              </i-col>
              <Col :span="2">
                <Button type="info" @click="addOpenedTime">添加</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form ref="timeListForm" class="form" :label-width="90"
          :model="{}" :rules="timeListRule">
      <Row>
        <Col :span="22">
          <Form-item label="已选择时间" prop="openedTimeList">
            <Row>
              <div v-for="(item, index) in openedTimeList" :key="item.week">
                <Col offset="1" :span="15">
                  <label><b>{{ item.weekStr }} {{ item.startTimeStr }} - {{ item.endTimeStr }} , &nbsp;&nbsp;
                    生效日期：{{ item.useDateStr }}, 结束日期：{{ item.endDateStr }}</b></label>
                </Col>
                <Col :span="1">
                  <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                </Col>
              </div>
            </Row>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="18">
          <Form-item label="备注" prop="remark">
            <Input v-model="remark" type="textarea" placeholder="如果是新增时间，请输入关闭的原因" :rows="3"/>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="false" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
import dates from '../../../tools/date/dates'

export default {
  name: 'TchEditCloseTimeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let self = this
    return {
      visible: this.value,
      remark: '',
      timeParam: {
        week: null,
        startTime: '',
        endTime: '',
        startTimeStr: '',
        endTimeStr: '',
        useDate: '',
        endDate: '',
        useDateStr: '',
        endDateStr: '',
        remark: ''
      },
      loadingAdd: false,
      openedTimeList: [],
      timeRule: {
        remark: [
          {type: 'string', required: true, message: '请输入关闭的原因', trigger: 'blur'}
        ],
        week: [
          {type: 'integer', required: true, message: '请选择星期', trigger: 'blur'}
        ],
        startTime: [
          {type: 'integer', required: true, message: '请选择开始时间', trigger: 'change'},
          {
            validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            }
          }
        ],
        endTime: [
          {type: 'integer', required: true, message: '请选择结束时间', trigger: 'change'}
        ],
        useDate: [
          {type: 'integer', required: true, message: '请选择有效日期', trigger: 'change'},
          {
            validator (rule, value, callback, source, options) {
              let endDate = self.timeParam.endDate
              let errors = []
              if (endDate !== '' && value >= endDate) {
                errors.push('生效日期应在结束日期之前 ')
              }
              callback(errors)
            }
          }
        ],
        endDate: [
          {type: 'integer', required: true, message: '请选择结束日期', trigger: 'change'}
        ],
        openedTime: [
          {
            validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let week = self.timeParam.week
              let startTime = self.timeParam.startTime
              let endTime = self.timeParam.endTime
              if (week === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              let errors = []
              openedTimeList.forEach(element => {
                let tmpWeek = element.week
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (week === tmpWeek &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                    (tmpStratTime < endTime && tmpEndTime > endTime) ||
                    (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' +
                    element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            }
          }
        ],
      },
      timeListRule: {
        openedTimeList: [
          {
            validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加关闭时间')
              }
              callback(errors)
            }
          }
        ]
      }
    }
  },
  methods: {
    addOpenedTime () {
      let self = this
      self.$refs.timeForm.validate((valid) => {
        if (!valid) {
          return
        }
        let openedTime = {}
        openedTime.week = this.timeParam.week
        openedTime.weekStr = this.$constant.weekZh[this.timeParam.week]
        openedTime.startTime = this.timeParam.startTime
        openedTime.startTimeStr = this.timeParam.startTimeStr
        openedTime.endTime = this.timeParam.endTime
        openedTime.endTimeStr = this.timeParam.endTimeStr
        openedTime.useDate = this.timeParam.useDate
        openedTime.endDate = this.timeParam.endDate
        openedTime.useDateStr = this.timeParam.useDateStr
        openedTime.endDateStr = this.timeParam.endDateStr
        this.openedTimeList.push(openedTime)
        this.timeParam.week = ''
        this.$refs.timeListForm.validate()
      })
    },
    removeOpenedTime (index) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '此操作将直接删除老师关闭时间，学生可以继续预约该老师！',
        width: 300,
        okText: '确定删除',
        loading: true,
        onOk: () => {
          self.openedTimeList.splice(index, 1)
          self.delect()
          self.$Modal.remove()
        }
      })
    },
    onChangeStratTime (val) {
      this.timeParam.startTime = this.$dateUtil.getSecondByHm(val)
      this.timeParam.startTimeStr = val
    },
    onChangeEndTime (val) {
      this.timeParam.endTime = this.$dateUtil.getSecondByHm(val)
      this.timeParam.endTimeStr = val
    },
    onChangeUseDate (val) {
      this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
      this.timeParam.useDateStr = val
    },
    onChangeEndDate (val) {
      this.timeParam.endDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
      this.timeParam.endDateStr = val
    },
    add () {
      let self = this
      if (self.openedTimeList.length === 0) {
        self.$http.get('/tch/time/deleteCloseTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.status === 'ok') {
            self.visible = false
            self.$Message.success('删除成功!')
          } else {
            self.$Message.error({
              content: res.data(),
              duration: 5
            })
          }
        })
      } else {
        if (self.remark === '') {
          self.$Message.error('请填写原因')
          return
        }
        self.openedTimeList.forEach(element => {
          element.tchId = self.tchId
          element.remark = self.remark
        })
        self.$http.post('/tch/time/addCloseTime', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.openedTimeList)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
//            self.loadingAdd = false
          if (res && res.status === 'ok') {
            self.visible = false
            self.$Message.success('提交成功!')
          } else {
            self.$Message.error({
              content: res.data(),
              duration: 5
            })
          }
        }).catch(function (e) {
//            self.loadingAdd = false
        })
//        })
      }
    },
    delect () {
      let self = this
      if (self.openedTimeList.length === 0) {
        self.$http.get('/tch/time/deleteCloseTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.status === 'ok') {
            self.successCallback()
            self.visible = false
            self.$Message.success('删除成功!')
          } else {
            self.successCallback()
            self.$Message.error({
              content: res.data(),
              duration: 5
            })
          }
        })
      } else {
        if (self.remark === '') {
          self.$Message.error('请填写原因')
          return
        }
        self.openedTimeList.forEach(element => {
          element.tchId = self.tchId
          element.remark = self.remark
        })
        self.$http.post('/tch/time/addCloseTime', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.openedTimeList)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
//            self.loadingAdd = false
          if (res && res.status === 'ok') {
            self.loadTchOpenedTime()
            self.successCallback()
            //  self.visible = false
            self.$Message.success('删除成功')
          } else {
            self.loadTchOpenedTime()
            self.$Message.error({
              content: res.data(),
              duration: 5
            })
          }
        }).catch(function (e) {
//            self.loadingAdd = false
        })
//        })
      }
    },
    loadTchOpenedTime () {
      let self = this
      self.$http.get('/tch/closeTime?tchId=' + self.tchId).then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.visible = true
        self.openedTimeList = []
        res.data.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week]
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm')
          element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm')
          element.useDateStr = dates.formatUnix(element.useDate, 'YYYY-MM-DD')
          element.endDateStr = dates.formatUnix(element.endDate, 'YYYY-MM-DD')
          self.openedTimeList.push(element)
        })
      })
    },
  },
  watch: {
    value (val) {
      if (val === true) {
        this.openedTimeList = []
        this.loadTchOpenedTime()
      }
      this.visible = val
    },
    visible (val) {
      if (val === false) {
        this.openedTimeList = []
        this.$refs.timeForm.resetFields()
        this.$refs.timeListForm.resetFields()
        this.timeParam = {
          week: null,
          remark: '',
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          endDate: '',
          useDateStr: '',
          endDateStr: ''
        }
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TchEditCloseTimeModal.vue?564bd22c